import React from 'react';

const BannerFieldwork = (props) => (
    <section id="banner" className="style2 fieldwork major">
        <div className="inner">
            <header className="major">
                <h1>Fieldwork</h1>
            </header>
            <div className="content">
                <p>Brief overview of my research</p>
            </div>
        </div>
    </section>
);

export default BannerFieldwork;
